import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router} from '@angular/router';
import { RouteService } from '../core/services';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AdminGuard implements CanActivate {

  constructor(public auth: AuthService, public router: Router, private routeService: RouteService) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {

    // Admin
    if(this.auth.getAdminStatus()) {
      return true;
    }

    // Not an admin
    else {
      const currentUrl = this.routeService.getResolvedUrl(route);
      const queryParams = { redirect: currentUrl };
      this.router.navigate(['/admin/login'], { queryParams });
      return false;
    }
  }
}
